/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Icon } from '@az/starc-ui';
import { Pause, Play } from '@az/starc-ui-icons';
import styles from './HeroControls.module.scss';
import { useLabels } from '@/hooks/useLabels';

type Props = {
  theme?: 'Dark' | 'Light';
  isPaused?: boolean;
  onTogglePause?: () => void;
  currentSlide?: number;
  totalSlides?: number;
};

const labelMap = {
  playLabel: 'label_play_carousel',
  pauseLabel: 'label_pause_carousel',
};

const HeroControls = ({
  theme = 'Light',
  isPaused = false,
  onTogglePause,
  currentSlide = 0,
  totalSlides = 1,
}: Props) => {
  const iconColor = theme === 'Dark' ? 'on-primary' : 'primary';
  const labels = useLabels(labelMap);

  return (
    <div
      className={`${styles.HeroControls} ${theme === 'Dark' ? styles.Dark : styles.Light}`}
      aria-label="Carousel controls"
      role="group"
    >
      <span className={styles.Counter}>
        {currentSlide + 1} of {totalSlides}
      </span>
      <button
        type="button"
        className={styles.PauseButton}
        aria-label={isPaused ? labels.playLabel : labels.pauseLabel}
        onClick={onTogglePause}
      >
        <Icon svg={isPaused ? Play : Pause} color={iconColor} size={6} />
      </button>
    </div>
  );
};

export default HeroControls;
